/**
 * 008-reporting-dashboards T008 (FR-001's ninth tile). Not one of tasks.md's T009 list — that list
 * predates `009` (billing/refunds) landing. `009` has since landed (`finance.ts`'s
 * `getOutstandingRefunds`/`bucketRefunds`, already proven live by `finance/Refunds.tsx`), so this
 * renders real data rather than the `unbuilt` arm the stale contract still names. Counts, never
 * sums money (constitution I) — same as `Refunds.tsx`'s own metric cards. Drawn by `StatusCard`.
 */
import { PiArrowCounterClockwiseDuotone as Undo } from "react-icons/pi";
import { TileBoundary } from "./TileBoundary";
import { StatusCard, UnreadableStatusCard } from "./StatusCard";
import { bucketRefunds, type OutstandingRefund } from "../../lib/services/finance";

const icon = <Undo aria-hidden className="size-5" />;

function unreadable(error: unknown) {
  return <UnreadableStatusCard title="Outstanding refunds" icon={icon} error={error} fallback="Could not be read — this is not the same as nothing outstanding." />;
}

export function OutstandingRefundsTile({ resolve }: { resolve: Promise<OutstandingRefund[]> }) {
  return (
    <TileBoundary resolve={resolve} errorFallback={unreadable}>
      {(refunds) => {
        const buckets = bucketRefunds(refunds);
        const count = buckets.queued.length + buckets.failed.length + buckets.unrecognised.length;
        return (
          <StatusCard
            title="Outstanding refunds"
            icon={icon}
            tone={buckets.failed.length > 0 ? "destructive" : count > 0 ? "warning" : "success"}
            value={count}
            caption={`${buckets.failed.length} failed, ${buckets.queued.length} queued.`}
            link={{ to: "/finance/refunds", label: "Open outstanding refunds" }}
          />
        );
      }}
    </TileBoundary>
  );
}
